import { lazy } from 'react';

const RequestAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/requests',
      component: lazy(() => import('./RequestApp')),
    },
  ],
};

export default RequestAppConfig;
